import React from "react";
import { Typography, Tooltip } from "@material-ui/core";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardTitle from "components/Card/CardTitle";
import CardFooter from "components/Card/CardFooter.js";
import NewCardBody from "components/Card/NewCardBody";

import DeleteIcon from "@material-ui/icons/Delete";

const ArtifactCard = ({ name, description, handleDeleteArtifact, artifact_id, artifact_type }) => {
    const images = require.context("assets/img/create_cards_16_9", true);

    const artifactTypeMappings = {
        "model_development": "Model Development Plan Generator",
        "model_validation": "Model Validation Plan Generator",
        "labs": "Concept Labs",
        "form": "Form Generator",
        "course": "Course",
        "research_report": "Research Report",
        "white_paper": "White Paper",
        "blog": "Blog",
        "news_letter": "Newsletter",
        "case_study": "Case Study",
        "handout": "Handout",
        "key_insights": "Key Insights",
        "podcast": "Podcast",
        "project_plan": "Project Plan"
    }

    return (
        <>
            <Card style={{ marginTop: "40px", border: "2px solid #20677b" }}>
                <CardHeader icon text>
                    {/* <CardTitle color="quCreateColor">{asset.name + asset.name + asset.name + asset.name + asset.name + asset.name + asset.name + asset.name}</CardTitle> */}
                    <CardTitle color="quCreateColor">{name}</CardTitle>
                </CardHeader>
                <NewCardBody image={images("./qcreate.png")}>
                    {/* {asset.description + asset.description + asset.description} */}
                    {description}
                </NewCardBody>

                <CardFooter stats style={{ marginTop: "0px", paddingBottom: "10px" }}>
                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                        {/* Artifact type on the left */}
                        <Tooltip title={"Artifact type: " + artifact_type} arrow>
                            <Typography
                                variant="body2"
                                style={{
                                    color: "#435966",
                                    whiteSpace: "nowrap", // Prevent text from wrapping
                                    overflow: "hidden", // Hide overflowing text
                                    textOverflow: "ellipsis", // Add ellipsis if text overflows
                                    maxWidth: "calc(100% - 60px)", // Ensure the text does not go past icons
                                }}
                            >
                                {artifactTypeMappings?.[artifact_type] || artifact_type}
                            </Typography>
                        </Tooltip>

                        {/* Icons on the right */}
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            {/* <Tooltip title="Invite Collaborator" arrow>
                            <PersonAddIcon
                                style={{ color: "#435966", marginLeft: "10px" }}
                                onClick={(e) => e.preventDefault(handleInviteCollaborators(asset))}
                            />
                        </Tooltip>
                        <Tooltip title="Tags" arrow>
                            <LabelIcon
                                style={{ color: "#435966", marginLeft: "10px" }}
                                onClick={(e) => e.preventDefault(handleTags(asset))}
                            />
                        </Tooltip>
                        <Tooltip title="Clone" arrow>
                            <FileCopyIcon
                                style={{ color: "#435966", marginLeft: "10px" }}
                                onClick={(e) => e.preventDefault(cloneAlert(asset))}
                            />
                        </Tooltip> */}
                            <Tooltip title="Remove artifact from project" arrow>
                                <DeleteIcon
                                    style={{ color: "#435966", marginLeft: "10px", cursor: "pointer" }}
                                    onClick={(e) => e.preventDefault(handleDeleteArtifact(artifact_id))}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </CardFooter>

            </Card>
        </>

    );
};

export default ArtifactCard;
